import { ChallengeDetailScreen } from '@fhs/loyalty';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default function ChallengeDetails() {
  return <ChallengeDetailScreen />;
}
